import { useTheme } from '@mui/material'

export const HighlightedWords = ({ children }) => {
  const theme = useTheme()
  return <strong style={{ color: theme.palette.primary[800] }}>{children}</strong>
}
